import { type ChangeEvent } from 'react';

interface QRInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function QRInput({ value, onChange }: QRInputProps) {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    onChange('');
  };

  const charCount = value.length;

  return (
    <div className="qr-input">
      <div className="input-header">
        <label htmlFor="qr-text-input">内容</label>
        <span className="char-count">{charCount} 字符</span>
      </div>
      <textarea
        id="qr-text-input"
        className="input-textarea"
        placeholder="输入文本、链接等内容生成二维码..."
        value={value}
        onChange={handleChange}
        rows={3}
        maxLength={2000}
      />
      <div className="input-actions">
        {value && (
          <button className="btn btn-sm btn-ghost" onClick={handleClear} type="button">
            清空
          </button>
        )}
      </div>
    </div>
  );
}
